import cn from 'classnames';
import { FieldValues, FormProvider } from 'react-hook-form';

import styles from '../styles.module.scss';
import { FormProps } from '../typing';
import { FormEnvironmentContext } from './formEnvironment';
import useFormLogic from './useFormLogic';

export default function Form<FieldsTypes extends FieldValues>({
  children,
  onSubmit,
  onChange,
  onValidChange,
  defaultValues,
  readonly,
  validateDefaultValues,
  onError,
  className,
  shouldUnregister,
}: FormProps<FieldsTypes>) {
  const { providerValue, formEnvironment, methods } = useFormLogic({
    defaultValues,
    onValidChange,
    onChange,
    validateDefaultValues,
    readonly,
    shouldUnregister,
  });

  return (
    <div
      className={cn(styles.form, {
        [styles.readonly]: readonly,
      })}
    >
      <FormProvider {...methods}>
        <FormEnvironmentContext.Provider value={providerValue}>
          <form
            onSubmit={methods.handleSubmit(
              (data: FieldsTypes) => {
                if (onSubmit) onSubmit(data, formEnvironment);
              },
              (errors, event) => {
                if (onError) return onError(errors, event);
              }
            )}
            className={className}
          >
            {children}
          </form>
        </FormEnvironmentContext.Provider>
      </FormProvider>
    </div>
  );
}
